import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes, FaSyncAlt, FaTable } from 'react-icons/fa';
import styles from '../../pages/Monitor/Monitor.module.css';
import { request } from '../../services/api';

const ArchiveTableModal = ({
    isOpen,
    onClose,
    serial,
    sensorKey,
    title,
    token
}) => {
    const [range, setRange] = useState('-24h');
    const [limit, setLimit] = useState(200);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

  const loadArchive = async () => {
    console.log('Archive loadArchive called:', {
        isOpen,
        serial,
        sensorKey,
        range,
        limit
    });

    if (!serial || !sensorKey) {
        setError(`اطلاعات سنسور کامل نیست. serial=${serial || 'خالی'} sensor=${sensorKey || 'خالی'}`);
        setRecords([]);
        return;
    }

    setLoading(true);
    setError('');

    try {
        const json = await request(
            `/get_sensor_archive.php?serial=${encodeURIComponent(serial)}&sensor=${encodeURIComponent(sensorKey)}&range=${encodeURIComponent(range)}&limit=${encodeURIComponent(limit)}`
        );

        console.log('Archive API response:', json);

        if (!json || json.status !== 'success') {
            throw new Error(json?.message || 'خطا در دریافت آرشیو');
        }

        setRecords(json.records || []);
    } catch (err) {
        console.error('Archive fetch error:', err);
        setError(err.message || 'خطای نامشخص');
        setRecords([]);
    } finally {
        setLoading(false);
    }
};
    useEffect(() => {
        if (isOpen) {
            loadArchive();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, serial, sensorKey, range, limit]);

    if (!isOpen) return null;

    const formatDateTime = (iso) => {
        try {
            return new Date(iso).toLocaleString('fa-IR');
        } catch {
            return iso;
        }
    };

    return  createPortal(
         <div style={overlayStyle}>
                <div style={modalStyle}>
                <div style={headerStyle}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FaTable color="#3498db" />
                        <strong>آرشیو جدولی {title || sensorKey}</strong>
                    </div>

                    <button onClick={onClose} style={iconButtonStyle}>
                        <FaTimes />
                    </button>
                </div>

                <div style={toolbarStyle}>
    <div style={{ ...toolbarItemStyle, justifyContent: 'flex-start' }}>
        <div style={filterItemStyle}>
            <span>بازه:</span>
            <select
                value={range}
                onChange={(e) => setRange(e.target.value)}
                style={selectStyle}
            >
                <option value="-1h">۱ ساعت اخیر</option>
                <option value="-6h">۶ ساعت اخیر</option>
                <option value="-12h">۱۲ ساعت اخیر</option>
                <option value="-24h">۲۴ ساعت اخیر</option>
                <option value="-7d">۷ روز اخیر</option>
                <option value="-30d">۳۰ روز اخیر</option>
                <option value="-90d">۹۰ روز اخیر</option>
            </select>
        </div>
    </div>

    <div style={{ ...toolbarItemStyle, justifyContent: 'center' }}>
        <div style={filterItemStyle}>
            <span>تعداد:</span>
            <select
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
                style={selectStyle}
            >
                <option value={50}>۵۰</option>
                <option value={100}>۱۰۰</option>
                <option value={200}>۲۰۰</option>
                <option value={500}>۵۰۰</option>
                <option value={1000}>۱۰۰۰</option>
            </select>
        </div>
    </div>

    <div style={{ ...toolbarItemStyle, justifyContent: 'flex-end' }}>
        <button onClick={loadArchive} style={refreshButtonStyle} disabled={loading}>
            <FaSyncAlt />
            {loading ? 'در حال دریافت...' : 'بروزرسانی'}
        </button>
    </div>
</div>

                <div style={infoStyle}>
    <span style={{ ...infoItemStyle, textAlign: 'right' }}>دستگاه: {serial}</span>
    <span style={{ ...infoItemStyle, textAlign: 'center' }}>سنسور: {sensorKey}</span>
    <span style={{ ...infoItemStyle, textAlign: 'left' }}>تعداد رکورد: {records.length}</span>
</div>

                {error && (
                    <div style={errorStyle}>
                        {error}
                    </div>
                )}

                <div style={tableWrapperStyle}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>ردیف</th>
                                <th style={thStyle}>زمان</th>
                                <th style={thStyle}>مقدار</th>
                                <th style={thStyle}>واحد</th>
                            </tr>
                        </thead>

                        <tbody>
                            {records.length === 0 && !loading ? (
                                <tr>
                                    <td colSpan="4" style={emptyStyle}>
                                        رکوردی برای نمایش وجود ندارد.
                                    </td>
                                </tr>
                            ) : (
                                records.map((row, index) => (
                                    <tr key={`${row.time}-${index}`}>
                                        <td style={tdStyle}>{index + 1}</td>
                                        <td style={tdStyle}>{formatDateTime(row.time)}</td>
                                        <td style={tdStyle}>{row.value}</td>
                                        <td style={tdStyle}>{row.unit || '-'}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>,
    document.body
    );
};

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.65)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
};

const modalStyle = {
    width: 'min(900px, 95vw)',
    maxHeight: '90vh',
    background: '#1f2d3a',
    color: '#fff',
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.45)',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.08)'
};

const headerStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '14px 48px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    background: '#17212b',
    direction: 'rtl',
    textAlign: 'center'
};

const iconButtonStyle = {
    position: 'absolute',
    left: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'transparent',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '16px'
};

const toolbarStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '18px',
    padding: '12px 16px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    direction: 'rtl'
};

const filterItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    direction: 'rtl'
};
 const toolbarItemStyle = {
    flex: '1 1 0',
    display: 'flex'
};

const selectStyle = {
    background: '#101820',
    color: '#fff',
    border: '1px solid #34495e',
    borderRadius: '6px',
    padding: '6px 8px',
    outline: 'none'
};

const refreshButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    background: '#3498db',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '7px 12px',
    cursor: 'pointer'
};

const infoStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '18px',
    padding: '10px 16px',
    fontSize: '12px',
    color: '#bdc3c7',
    direction: 'rtl',
    textAlign: 'right'
};
const infoItemStyle = {
    flex: '1 1 0'
};

const errorStyle = {
    margin: '0 16px 10px',
    padding: '10px',
    background: 'rgba(231, 76, 60, 0.15)',
    border: '1px solid rgba(231, 76, 60, 0.4)',
    color: '#ffb3b3',
    borderRadius: '6px',
    fontSize: '13px'
};

const tableWrapperStyle = {
    maxHeight: '58vh',
    overflow: 'auto',
    padding: '0 16px 16px'
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
    direction: 'rtl'
};

const thStyle = {
    position: 'sticky',
    top: 0,
    background: '#101820',
    color: '#f1c40f',
    padding: '10px',
    borderBottom: '1px solid rgba(255,255,255,0.12)',
    textAlign: 'right'
};

const tdStyle = {
    padding: '9px 10px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    color: '#ecf0f1'
};

const emptyStyle = {
    padding: '30px',
    textAlign: 'center',
    color: '#95a5a6'
};

export default ArchiveTableModal;